import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsersDashboardInfoResponse } from '@edtech-ui/core/models/admin-panel/admin-panel-models';
import { 
    DashboardOverviewData, 
    DashboardOverviewResponse, 
    DashboardEntitiesResponse, 
    PaginatedDashboardEntities 
} from '@edtech-ui/core/models/admin-student-platform/admin-student-dashboard';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdminDashboardService {
    apiUrl = environment.adminDashboardUrl;

    constructor(private http: HttpClient) { }

    getDashboardInfo(): Observable<UsersDashboardInfoResponse> {
        return this.http.get<UsersDashboardInfoResponse>(
            `${this.apiUrl}${environment.adminDashboardEndpoints.adminStats}`
        );
    }

    getDashboardOverview(
        scope: string = 'platform',
        entityId?: string,
        timeRange: string = 'all_time',
        fromDate?: string,
        toDate?: string
    ): Observable<DashboardOverviewData> {
        let params = new HttpParams()
            .set('scope', scope)
            .set('time_range', timeRange);

        if (entityId) {
            params = params.set('entity_id', entityId);
        }
        if (fromDate) {
            params = params.set('from_date', fromDate);
        }
        if (toDate) {
            params = params.set('to_date', toDate);
        }

        return this.http
            .get<DashboardOverviewResponse>(
                `${this.apiUrl}${environment.adminDashboardEndpoints.dashboardOverview}`,
                { params }
            )
            .pipe(map(res => res.Data));
    }

    searchDashboardEntities(
        type: 'college' | 'company',
        search?: string,
        page: number = 1,
        limit: number = 100
    ): Observable<PaginatedDashboardEntities> {
        let params = new HttpParams()
            .set('type', type)
            .set('page', page.toString())
            .set('limit', limit.toString());

        if (search && search.trim()) {
            params = params.set('search', search.trim());
        }

        return this.http
            .get<DashboardEntitiesResponse>(
                `${this.apiUrl}${environment.adminDashboardEndpoints.dashboardEntities}`,
                { params }
            )
            .pipe(map(res => res.Data));
    }
}